export const GET_DRUGS__REQUEST = 'DRUGS_TYPE__GET_DRUGS__REQUEST'
export const GET_DRUGS__FAILURE = 'DRUGS_TYPE__GET_DRUGS__FAILURE'
export const GET_DRUGS__SUCCESS = 'DRUGS_TYPE__GET_DRUGS__SUCCESS'
